import { isNil, isString, toString, upperFirst } from 'gleam-shared/helpers/nodash'

const DEFAULT_TERMINAL = '.'

const TRIM_INTERNAL_RE = /[\s,:;-]+$/
const TRIM_PUNCTUATIONS_RE = /[\s.?!,:;-]+$/

const STARTS_WITH_HTTP_RE = /^https?:\/\//
const STARTS_WITH_SNAKE_RE = /^[a-z0_9]+_[a-z0_9]/i
const ENDS_WITH_TERMINAL_RE = /[.?!]$/
const HAS_ONLY_PUNCTUATIONS_RE = /^[\s.?!,:;-]+$/

export function unSentence(input) {
  if (isNil(input)) {
    return ''
  }

  if (!isString(input)) {
    return toString(input)
  }

  return input.replace(TRIM_PUNCTUATIONS_RE, '')
}

export default function toSentence(input) {
  if (isNil(input)) {
    return ''
  }

  if (!isString(input)) {
    return toString(input)
  }

  if (HAS_ONLY_PUNCTUATIONS_RE.test(input)) {
    return ''
  }

  const prepared = opinionatedUpperFirst(opinionatedTrim(input))

  if (prepared.length === 0) {
    return ''
  }

  if (ENDS_WITH_TERMINAL_RE.test(prepared)) {
    return prepared
  } else {
    return prepared + DEFAULT_TERMINAL
  }
}

function opinionatedTrim(input) {
  return input.replace(TRIM_INTERNAL_RE, '').trim()
}

function opinionatedUpperFirst(input) {
  if (STARTS_WITH_HTTP_RE.test(input) || STARTS_WITH_SNAKE_RE.test(input)) {
    return input
  } else {
    return upperFirst(input)
  }
}
